import axios from "axios";
import { toast, Bounce } from "react-toastify";
import { useState, useEffect } from "react";
import { useAudio, useAudioList } from "../Stores/useAudio";
import { useDispatch, useSelector } from "react-redux";
import { getClaims, fullyApproved, getAllValue, getBadge, deleteClaim } from "../../action";
import { AFCASOWRow } from '../AFCASOWRow'
import { DeclinedClaimRow } from "../DeclinedClaimRow";
import { EggHatchedRow } from "../EggHatchedRow";


export const CashSettlementRow = ({
  address,
  description,
  index,
  claimantId,
  claimantName,
  insurer,
  status,
  type,
  firstQuiz,
  cashStartTime,
  timestamps
}) => {
  const jwtToken = localStorage.getItem("jwtToken");

  const [modalOpen, setModalOpen] = useState(false);
  const [step, setStep] = useState(0);
  const [choice, setChoice] = useState("");
  const [amount, setAmount] = useState(0);
  const [date, setDate] = useState("");
  const { setAudioURL } = useAudio();
  const { celebrateAudios } = useAudioList();
  const dispatch = useDispatch();
  const state = useSelector((state) => state.reducer);
  const [cashStartFinalTime, setCashStartFinalTime] = useState("");
  const [isShow, setIsShow] = useState(true);
  const [open, setOpen] = useState(false);

  const keys = timestamps ? Object.keys(timestamps).sort((a, b) => new Date(timestamps[a]) - new Date(timestamps[b])) : [];
  const results = keys.map((key) => {
    const currentDate = new Date(timestamps[key]);
    const today = new Date();
    const diffTime = Math.abs(today - currentDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return { timestamp: key, daysAgo: diffDays };
  });

  useEffect(() => {
    if (cashStartTime) {
      const dateObj = new Date(cashStartTime);
      const today = new Date();
      const origianlDate = new Date(dateObj.toDateString());
      const todayDateOnly = new Date(today.toDateString());
      const diffTime = todayDateOnly - origianlDate;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      setCashStartFinalTime(diffDays);
    }
  }, [cashStartTime]);
  let total = 0;
  state.claimsData?.forEach(claim => {
    if (claim.addedAFCASowId === claimantId) {
      if (claim.status === "AFCA SOW") total++;
      if (claim.status === "Cash Settlement") total++;
      if (claim.status === "Variation") total++;
      if (claim.status === "Claim Declined") total++;
    }
  });
  const handleCashSettlement = () => {

    if (amount === "") {
      toast.warn("Please enter the amount!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else if (date === "") {
      toast.warn("Please enter the date!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else {
      axios
        .post(
          `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/finalize-cash-settlement`,
          { amount: amount, date: date, choice: choice },
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.message) {
            toast.success(res.data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              transition: Bounce,
            });
            dispatch(getClaims());
            dispatch(getAllValue());
            dispatch(getBadge());
            if (res.data.badgeUnlock !== "") {
              if (res.data.badgeUnlock.includes('Early Bird')) {
                setAudioURL(["/sounds/badge/badge7.mp3"]);
                dispatch({ type: "SET_BADGE_GIFT", payload: `Successfully Egg Hatched, added ${res.data.badgeUnlock} badges!` })
              } else if (res.data.badgeUnlock.includes('Settlement King')) {
                setAudioURL(["/sounds/badge/badge13.mp3"]);
                dispatch({ type: "SET_BADGE_GIFT", payload: `Successfully Egg Hatched, added ${res.data.badgeUnlock} badges!` })
              } else if (res.data.badgeUnlock.includes('Superstar Agent')) {
                setAudioURL(["/sounds/badge/badge29.mp3"]);
                dispatch({ type: "SET_BADGE_GIFT", payload: `Successfully Egg Hatched, added ${res.data.badgeUnlock} badges!` })
              } else if (res.data.badgeUnlock.includes('Scope King')) {
                setAudioURL(["/sounds/badge/badge5.mp3"]);
                dispatch({ type: "SET_BADGE_GIFT", payload: `Successfully Egg Hatched, added ${res.data.badgeUnlock} badges!` })
              } else if (res.data.badgeUnlock.includes('2.5K Club')) {
                setAudioURL(["/sounds/badge/badge18.mp3"]);
                dispatch({ type: "SET_BADGE_GIFT", payload: `Successfully Egg Hatched, added ${res.data.badgeUnlock} badges!` })
              } else if (res.data.badgeUnlock.includes('5K Club')) {
                setAudioURL(["/sounds/badge/badge19.mp3"]);
                dispatch({ type: "SET_BADGE_GIFT", payload: `Successfully Egg Hatched, added ${res.data.badgeUnlock} badges!` })
              } else if (res.data.badgeUnlock.includes('10K Club')) {
                setAudioURL(["/sounds/badge/badge20.mp3"]);
                dispatch({ type: "SET_BADGE_GIFT", payload: `Successfully Egg Hatched, added ${res.data.badgeUnlock} badges!` })
              } else if (res.data.badgeUnlock.includes('25K Club')) {
                setAudioURL(["/sounds/badge/badge21.mp3"]);
                dispatch({ type: "SET_BADGE_GIFT", payload: `Successfully Egg Hatched, added ${res.data.badgeUnlock} badges!` })
              } else if (res.data.badgeUnlock.includes('50K Club')) {
                setAudioURL(["/sounds/badge/badge22.mp3"]);
                dispatch({ type: "SET_BADGE_GIFT", payload: `Successfully Egg Hatched, added ${res.data.badgeUnlock} badges!` })
              } else if (res.data.badgeUnlock.includes('75K Club')) {
                setAudioURL(["/sounds/badge/badge23.mp3"]);
                dispatch({ type: "SET_BADGE_GIFT", payload: `Successfully Egg Hatched, added ${res.data.badgeUnlock} badges!` })
              } else if (res.data.badgeUnlock.includes('100K Club')) {
                setAudioURL(["/sounds/badge/badge24.mp3"]);
                dispatch({ type: "SET_BADGE_GIFT", payload: `Successfully Egg Hatched, added ${res.data.badgeUnlock} badges!` })
              } else if (res.data.badgeUnlock.includes('Power Closer')) {
                setAudioURL(["/sounds/badge/badge12.mp3"]);
                dispatch({ type: "SET_BADGE_GIFT", payload: `Successfully Egg Hatched, added Power Closer badge!` })
              }
            } else {
              setAudioURL(celebrateAudios);
              dispatch({ type: "SET_BADGE_GIFT", payload: "Successfully Egg Hatched" })
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return type === 1 ? (
    <>
      <tr key={index} className="border-t">
        <td className="px-6 py-4 text-center">{address}</td>
        <td className="px-6 py-4 text-center">{claimantName}</td>
        <td className="px-6 py-4 text-center">{insurer}</td>
        <td className="px-6 py-4 text-center">{description}</td>
        <td className="px-6 py-4 text-center relative">
          <div
              className="bg-blue-50 hover:bg-blue-100 px-2 py-1 border border-blue-100 rounded-2xl w-max mx-auto text-blue-700 cursor-pointer"
              onMouseEnter={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}
            >
              {status}
              {open && (
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-white shadow-lg rounded-xl p-4 w-56 z-10 text-sm">
                  {results?.map((item, idx) => (
                    <div key={idx} className="mb-2">
                      <strong>{
                        item.timestamp === "createdAt" ? "Authorized" :   
                        item.timestamp === "assessmentStart" ? "Under Assessment" :
                        item.timestamp === "appealStart" ? "Appeal in Progress" :
                        item.timestamp === "afcaWonDate" ? "Scope of Works" :
                        item.timestamp === "cashSettlementDate" ? "Cash Settlement" :
                        item.timestamp === "eggHatchedDate" ? "Egg Hatched" :
                        item.timestamp === "afcaAppealMadeDate" ? "AFCA Appeal" :
                        item.timestamp === "afcaAppealMadeDate" ? "AFCA Appeal" :
                        item.timestamp === "declinedDate" ? "AFCA Claim Denied" : ""
                      }</strong>: {item.daysAgo} day{item.daysAgo !== 1 && 's'}
                    </div>
                ))}
              </div>
              )}
          </div>
        </td>
        <td className="px-6 py-4 text-center"></td>
        <td className="px-6 py-4 text-center">
          <div className="space-y-2">
            {
              state.role === 0 ? (
                <div className="space-y-2">
                  <button
                    onClick={() => setModalOpen(true)}
                    className="relative w-full px-5 py-2  tracking-wide text-white uppercase rounded-lg bg-gradient-to-br from-green-400 to-green-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-green-500 hover:to-green-700 hover:shadow-2xl active:scale-95 animate-pulse-glow"
                  >
                    <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                    <span className="relative z-10">EGG HATCHED</span>
                  </button>

                  <button
                    onClick={(e) => dispatch(fullyApproved(claimantId, "undo"))}
                    className="relative w-full px-5 py-2  tracking-wide text-white uppercase rounded-lg bg-gradient-to-br from-red-400 to-red-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl active:scale-95 animate-pulse-glow"
                  >
                    <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                    <span className="relative z-10">Undo</span>
                  </button>
                </div>
              ) : (
                <button
                  onClick={(e) => dispatch(deleteClaim(claimantId, state.currentUserName))}
                  className="relative px-5 py-2  tracking-wide text-white uppercase rounded-lg bg-gradient-to-br from-red-400 to-red-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl active:scale-95 animate-pulse-glow"
                >
                  <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                  <span className="relative z-10">Delete</span>
                </button>
              )
            }
            

            {/* Modal */}
            <div
              className={`fixed left-0 top-0 flex h-full min-h-screen w-full items-center justify-center bg-dark/90 px-4 py-5 ${
                modalOpen ? "block" : "hidden"
              }`}
            >
              <div className="flex flex-col gap-y-4 bg-white dark:bg-dark-2 shadow-xl p-4 rounded-[20px] w-full max-w-[570px] text-center">
                {step === 0 ? (
                  <div className="flex flex-wrap gap-4">
                    <button
                      onClick={() => {
                        setStep(1);
                        setChoice("Easy Hail Fee");
                      }}
                      className="flex-1 hover:bg-blue-600 p-3 border border-stroke hover:border-blue-600 rounded-md font-medium text-black hover:text-white transition"
                    >
                      Easy Hail Fee
                    </button>
                    <button
                      onClick={() => {
                        setStep(1);
                        setChoice("Roof Replacement");
                      }}
                      className="flex-1 hover:bg-blue-600 p-3 border border-stroke hover:border-blue-600 rounded-md font-medium text-black hover:text-white transition"
                    >
                      Roof Replacement
                    </button>
                  </div>
                ) : null}

                {step === 1 ? (
                  <>
                    <div className="flex gap-4">
                      <input
                        className="p-2 border w-1/2"
                        type="number"
                        placeholder="Enter the total cash settlement amount"
                        onChange={(e) => setAmount(e.target.value)}
                      />
                      <input
                        type="date"
                        className="p-2 border w-1/2"
                        onChange={(e) => setDate(e.target.value)}
                      />
                    </div>
                    <div className="flex gap-4">
                      <button
                        className="bg-red-600 px-4 py-3 rounded-md w-full text-white"
                        onClick={() => {
                          setModalOpen(false);
                          setStep(0);
                        }}
                      >
                        Close
                      </button>
                      <button
                        className="bg-blue-600 px-4 py-3 rounded-md w-full text-white"
                        onClick={() => {
                          handleCashSettlement();
                          setModalOpen(false);
                          setStep(0);
                        }}
                      >
                        OK
                      </button>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
          {
            total > 0 && (
              <button
                className={`relative w-full mt-2 px-4 py-2 rounded-md text-sm font-medium bg-gradient-to-br from-green-400 to-green-600 shadow-lg hover:scale-105 hover:from-green-500 hover:to-green-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow`}
                onClick={() => {
                  setIsShow(!isShow)
                }}
              >
                <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                <span className="relative z-10 text-white">{isShow ? "hide" : "show"}</span>
              </button>
            )
          }
        </td>
        <td className="text-center">
          {
          cashStartFinalTime === 0 ? "Today" : (`${cashStartFinalTime} days`)
          }
        </td>
      </tr>
       { isShow &&
        state.claimsData?.map((claim, index) => {
          return claim.addedAFCASowId === claimantId && claim.status === "AFCA SOW" ?
          (
            <tr>
                <AFCASOWRow
                  address={claim.address}
                  description={claim.description}
                  key={index}
                  index={0}
                  claimantId={claim._id}
                  claimantName={claim.claimantName}
                  insurer={claim.insurerName}
                  status={claim.status}
                  sowStarttime={claim.timers.afcaSOWsentDate}
                  firstQuiz={claim.partiallyApprovedQuestions.firstQuiz}
                  secondQuiz={claim.partiallyApprovedQuestions.secondQuiz}
                  type={2}
                />
            </tr>
          ) : claim.addedAFCASowId === claimantId && claim.status === "Cash Settlement" ? 
          (
            <tr>
              <CashSettlementRow
                address={claim.address}
                description={claim.description}
                key={index}
                index={0}
                claimantId={claim._id}
                claimantName={claim.claimantName}
                insurer={claim.insurerName}
                status={claim.status}
                type={2}
                firstQuiz={claim.partiallyApprovedQuestions.firstQuiz}
                cashStartTime={claim.timestamps.cashSettlementDate}
              />
            </tr>
          ) : claim.addedAFCASowId === claimantId && claim.status === "Variation" ? 
          (
            <tr>
              <EggHatchedRow
                address={claim.address}
                description={claim.description}
                key={index}
                index={0}
                claimantId={claim._id}
                claimantName={claim.claimantName}
                insurer={claim.insurerName}
                status={claim.status}
                eggHatchedDate={claim.timestamps.eggHatchedDate}
                choise={claim.cashSettlement.settlementChoice}
                type={2}
                firstQuiz={claim.partiallyApprovedQuestions.firstQuiz}
              />
            </tr>
          ) : claim.addedAFCASowId === claimantId && claim.status === "Child Claim Declined" ? 
          (
            <tr>
              <DeclinedClaimRow
                address={claim.address}
                description={claim.description}
                key={index}
                index={0}
                claimantId={claim._id}
                claimantName={claim.claimantName}
                insurer={claim.insurerName}
                status={claim.status}
                declinedDate={claim.timestamps.declinedDate}
                type={2}
              />
            </tr>
          ) : null
        })
      }
    </>
     
  ) : (
    <>
      <td className="px-6 py-4 text-center">{address}</td>
      <td className="px-6 py-4 text-center">{claimantName}</td>
      <td className="px-6 py-4 text-center">{insurer}</td>
      <td className="px-6 py-4 text-center">{description}</td>
      <td className="px-6 py-4 text-center">
        <div className="bg-blue-50 hover:bg-blue-50 px-2 border-blue-100 rounded-2xl w-max text-blue-700">
          {status}
        </div>
      </td>
      <td className="px-6 py-4 text-center">{firstQuiz}</td>
      <td className="px-6 py-4 text-center">
        <div className="space-y-2">
          {
            state.role === 0 && (
              <div className="space-y-2">
                <button
                  onClick={() => setModalOpen(true)}
                  className="relative w-full px-5 py-2  tracking-wide text-white uppercase rounded-lg bg-gradient-to-br from-green-400 to-green-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-green-500 hover:to-green-700 hover:shadow-2xl active:scale-95 animate-pulse-glow"
                >
                  <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                  <span className="relative z-10">EGG HATCHED</span>
                </button>

                <button
                  onClick={(e) => dispatch(fullyApproved(claimantId, "undo"))}
                  className="relative w-full px-5 py-2 tracking-wide text-white uppercase rounded-lg bg-gradient-to-br from-red-400 to-red-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl active:scale-95 animate-pulse-glow"
                >
                  <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                  <span className="relative z-10">Undo</span>
                </button>
              </div>
            )
          }
          

          {/* Modal */}
          <div
            className={`fixed left-0 top-0 flex h-full min-h-screen w-full items-center justify-center bg-dark/90 px-4 py-5 ${
              modalOpen ? "block" : "hidden"
            }`}
          >
            <div className="flex flex-col gap-y-4 bg-white dark:bg-dark-2 shadow-xl p-4 rounded-[20px] w-full max-w-[570px] text-center">
              {step === 0 ? (
                <div className="flex flex-wrap gap-4">
                  <button
                    onClick={() => {
                      setStep(1);
                      setChoice("Easy Hail Fee");
                    }}
                    className="flex-1 hover:bg-blue-600 p-3 border border-stroke hover:border-blue-600 rounded-md font-medium text-black hover:text-white transition"
                  >
                    Easy Hail Fee
                  </button>
                  <button
                    onClick={() => {
                      setStep(1);
                      setChoice("Roof Replacement");
                    }}
                    className="flex-1 hover:bg-blue-600 p-3 border border-stroke hover:border-blue-600 rounded-md font-medium text-black hover:text-white transition"
                  >
                    Roof Replacement
                  </button>
                </div>
              ) : null}

              {step === 1 ? (
                <>
                  <div className="flex gap-4">
                    <input
                      className="p-2 border w-1/2"
                      type="number"
                      placeholder="Enter the total cash settlement amount"
                      onChange={(e) => setAmount(e.target.value)}
                    />
                    <input
                      type="date"
                      className="p-2 border w-1/2"
                      onChange={(e) => setDate(e.target.value)}
                    />
                  </div>
                  <div className="flex gap-4">
                    <button
                      className="bg-red-600 px-4 py-3 rounded-md w-full text-white"
                      onClick={() => {
                        setModalOpen(false);
                        setStep(0);
                      }}
                    >
                      Close
                    </button>
                    <button
                      className="bg-blue-600 px-4 py-3 rounded-md w-full text-white"
                      onClick={() => {
                        handleCashSettlement();
                        setModalOpen(false);
                        setStep(0);
                      }}
                    >
                      OK
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>
          {
            total > 0 && (
              <button
                className={`relative w-full mt-2 px-4 py-2 rounded-md text-sm font-medium bg-gradient-to-br from-green-400 to-green-600 shadow-lg hover:scale-105 hover:from-green-500 hover:to-green-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow`}
                onClick={() => {
                  setIsShow(!isShow)
                }}
              >
                <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                <span className="relative z-10 text-white">{isShow ? "hide" : "show"}</span>
              </button>
            )
          }
      </td>
      <td className="text-center border-t">
        {
        cashStartFinalTime === 0 ? "Today" : (`${cashStartFinalTime} days`)
        }
      </td>
    </>
  )
};
